module.exports = __webpack_public_path__ + "static/media/scissor-and-comb.0f65d0ec.svg";